/* eslint-disable no-sequences */
// AXIOS
import axios from "axios";

// api url
import { apiUrl_forCustomers, apiUrl, apiToken } from "./constants";

// cancel token
const CancelToken = axios.CancelToken;

// get customers
export let cancelGetCustomersApi;
export async function getCustomers(token, query = "") {
    if (token) {
        const customers = await axios.get(apiUrl_forCustomers + "/?" + query, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Api-Token": apiToken,
                "Access-Token": "",
            },
            cancelToken: new CancelToken(function executor(c) {
                // An executor function receives a cancel function as a parameter
                cancelGetCustomersApi = c;
            }),
        });
        return customers;
    } else {
        console.log("Please add required parameters");
    }
}

// get customer detail
export let cancelGetCustomerDetailsApi;
export async function getCustomerDetails(token, id) {
    if (token && id) {
        const customers = await axios.get(apiUrl_forCustomers + "/" + id, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Api-Token": apiToken,
                "Access-Token": "",
            },
            cancelToken: new CancelToken(function executor(c) {
                // An executor function receives a cancel function as a parameter
                cancelGetCustomerDetailsApi = c;
            }),
        });
        return customers;
    } else {
        console.log("Please add required parameters");
    }
}

// add customer
export let cancelAddCustomerApi;
export async function addCustomer(token, customerData) {
    if ((token, customerData)) {
        const customers = await axios.post(
            apiUrl_forCustomers + "/",
            customerData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelAddCustomerApi = c;
                }),
            }
        );
        return customers;
    } else {
        console.log("Please add required parameters");
    }
}

// update customer
export let cancelEditCustomerApi;
export async function editCustomer(token, customerData) {
    if ((token, customerData)) {
        const customers = await axios.put(
            apiUrl_forCustomers + "/" + customerData.user_id,
            customerData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelEditCustomerApi = c;
                }),
            }
        );
        return customers;
    } else {
        console.log("Please add required parameters");
    }
}

// update customer
export let cancelPasswordCustomerApi;
export async function resetPassCustomer(token, userId, password) {
    if (token && userId && password) {
        const customers = await axios.put(
            apiUrl_forCustomers + "/password/" + userId,
            { password },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelPasswordCustomerApi = c;
                }),
            }
        );
        return customers;
    } else {
        console.log("Please add required parameters");
    }
}

// delete customer
export let cancelDeleteCustomerApi;
export async function deleteCustomer(token, id) {
    if (token && id) {
        const customers = await axios.delete(
            apiUrl_forCustomers + "/" + id,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelDeleteCustomerApi = c;
                }),
            }
        );
        return customers;
    } else {
        console.log("Please add required parameters");
    }
}

// get customergroups
export let cancelGetCustomerGroupsApi;
export async function getCustomerGroups(token, query = "") {
    if (token) {
        const customergroups = await axios.get(
            apiUrl_forCustomers + "/groups?" + query,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelGetCustomerGroupsApi = c;
                }),
            }
        );
        return customergroups;
    } else {
        console.log("Please add required parameters");
    }
}

// get customergroup detail
export let cancelGetCustomerGroupDetailsApi;
export async function getCustomerGroupDetails(token, groupId) {
    if (token && groupId) {
        const customergroups = await axios.get(
            apiUrl_forCustomers + "/group/" + groupId,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelGetCustomerGroupDetailsApi = c;
                }),
            }
        );
        return customergroups;
    } else {
        console.log("Please add required parameters");
    }
}

// add customergroup
export let cancelAddCustomerGroupApi;
export async function addCustomerGroup(token, customergroupData) {
    if ((token, customergroupData)) {
        const customergroups = await axios.post(
            apiUrl_forCustomers + "/group",
            customergroupData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelAddCustomerGroupApi = c;
                }),
            }
        );
        return customergroups;
    } else {
        console.log("Please add required parameters");
    }
}

// update customergroup
export let cancelEditCustomerGroupApi;
export async function editCustomerGroup(token, customergroupData) {
    if ((token, customergroupData)) {
        const customergroups = await axios.put(
            apiUrl_forCustomers + "/group/" + customergroupData.group_id,
            customergroupData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelEditCustomerGroupApi = c;
                }),
            }
        );
        return customergroups;
    } else {
        console.log("Please add required parameters");
    }
}

// delete customergroup
export let cancelDeleteCustomerGroupApi;
export async function deleteCustomerGroup(token, groupId) {
    if ((token, groupId)) {
        const customergroups = await axios.delete(
            apiUrl_forCustomers + "/group/" + groupId,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelDeleteCustomerGroupApi = c;
                }),
            }
        );
        return customergroups;
    } else {
        console.log("Please add required parameters");
    }
}

// get customerCountries
export let cancelGetCustomerCountries;
export async function getCustomerCountries() {
    const customerCountries = await axios.get(
        apiUrl_forCustomers + "/countries",
        {
            headers: {
                Authorization: `Bearer ${""}`,
                "Api-Token": apiToken,
                "Access-Token": "",
            },
            cancelToken: new CancelToken(function executor(c) {
                // An executor function receives a cancel function as a parameter
                cancelGetCustomerCountries = c;
            }),
        }
    );
    return customerCountries;
}

// get customerStates
export let cancelGetCustomerStates;
export async function getCustomerStates(country_id) {
    if (country_id) {
        const customerStates = await axios.get(
            apiUrl_forCustomers + "/state/country/" + country_id,
            {
                headers: {
                    Authorization: `Bearer ${""}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelGetCustomerStates = c;
                }),
            }
        );
        return customerStates;
    } else {
        console.log("country id missing");
    }
}

// get customerCities
export let cancelGetCustomerCities;
export async function getCustomerCities(region_id) {
    if (region_id) {
        const customerCities = await axios.get(
            apiUrl_forCustomers + "/city/state/" + region_id,
            {
                headers: {
                    Authorization: `Bearer ${""}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelGetCustomerCities = c;
                }),
            }
        );
        return customerCities;
    } else {
        console.log("state id missing");
    }
}

// get CustomerAddresses
export let cancelGetCustomerAddessesApi;
export async function getCustomerAddresses(token, customer_id) {
    if (token && customer_id) {
        const customerAddresses = await axios.get(
            apiUrl_forCustomers + "/addresses/" + customer_id,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelGetCustomerAddessesApi = c;
                }),
            }
        );
        return customerAddresses;
    } else {
        console.log("Please add required parameters");
    }
}

// add customergroup
export let cancelAddCustomerAddressApi;
export async function addCustomerAddress(token, addressData) {
    if ((token, addressData)) {
        const customerAddress = await axios.post(
            apiUrl_forCustomers + "/address/" + addressData.user_id,
            addressData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelAddCustomerAddressApi = c;
                }),
            }
        );
        return customerAddress;
    } else {
        console.log("Please add required parameters");
    }
}

// update customergroup
export let cancelEditCustomerAddressApi;
export async function editCustomerAddress(token, addressData) {
    if ((token, addressData)) {
        const customerAddress = await axios.put(
            apiUrl_forCustomers + "/address/" + addressData.address_id,
            addressData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelEditCustomerAddressApi = c;
                }),
            }
        );
        return customerAddress;
    } else {
        console.log("Please add required parameters");
    }
}

// delete customergroup
export let cancelDeleteCustomerAddressApi;
export async function deleteCustomerAddress(token, id) {
    if ((token, id)) {
        const customerAddress = await axios.delete(
            apiUrl_forCustomers + "/address/" + id,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelDeleteCustomerAddressApi = c;
                }),
            }
        );
        return customerAddress;
    } else {
        console.log("Please add required parameters");
    }
}

//
export let cancelDefaultCustomerAddressApi;
export async function defaultCustomerAddress(token, id) {
    if ((token, id)) {
        const customerAddress = await axios.put(
            apiUrl_forCustomers + "/address/default/" + id,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelDefaultCustomerAddressApi = c;
                }),
            }
        );
        return customerAddress;
    } else {
        console.log("Please add required parameters");
    }
}

// send reset password email
export let cancelSendResetPasswordApi;
export async function sendResetPassword(email) {
    if (email) {
        const users = await axios.post(
            apiUrl + "/send/reset/password",
            {
                email,
            },
            {
                headers: {
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelSendResetPasswordApi = c;
                }),
            }
        );
        return users;
    } else {
        console.log("Please add required parameters");
    }
}

// validatin password email
export let cancelValidateResetPasswordApi;
export async function validateResetPassword({ userId, userToken }) {
    if (userId && userToken) {
        const users = await axios.get(
            apiUrl + `/reset/password/${userId}/${userToken}`,
            {
                headers: {
                    Authorization: `Bearer ${""}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelValidateResetPasswordApi = c;
                }),
            }
        );
        return users;
    } else {
        console.log("Please add required parameters");
    }
}

// reset password
export let cancelResetPasswordApi;
export async function resetPassword({ userId, userToken, password }) {
    if (userId && userToken) {
        const users = await axios.post(
            apiUrl + `/reset/password/${userId}/${userToken}`,
            {
                password,
                confirm_password: password,
            },
            {
                headers: {
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelResetPasswordApi = c;
                }),
            }
        );
        return users;
    } else {
        console.log("Please add required parameters");
    }
}
